import { render, staticRenderFns } from "./AllowedAgencyProjectsView.vue?vue&type=template&id=70169cbc&scoped=true&"
import script from "./AllowedAgencyProjectsView.vue?vue&type=script&lang=js&"
export * from "./AllowedAgencyProjectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70169cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VLayout})
